export function setErrors(errors, actions) {
    if (errors) {
        if (errors.email) {
            for (const e of errors.email) {
                switch (e) {
                    case "unique":
                        actions.setFieldError('email', 'Die E-Mail Adresse ist bereits vergeben.')
                    case "equal":
                        actions.setFieldError('email2', 'Die E-Mail Adressen stimmen nicht überein.')
                }
            }
        }
        if (errors.password) {
            for (const e of errors.password) {
                switch (e) {
                    case "equal":
                        actions.setFieldError('password2', 'Die Passwörter stimmen nicht überein.')
                }
            }
        }
        if (errors.phone) {
            for (const e of errors.phone) {
                switch (e) {
                    case "unique":
                        actions.setFieldError('phone', 'Die Handynummer ist bereits vergeben.')
                }
            }
        }
        if (errors.first_name) {
            for (const e of errors.first_name) {
                switch (e) {
                    case "unique":
                        actions.setFieldError('first_name', 'Es existiert bereits Jemand mit diesem Namen.')
                }
            }
        }
        if (errors.last_name) {
            for (const e of errors.last_name) {
                switch (e) {
                    case "unique":
                        actions.setFieldError('last_name', 'Es existiert bereits Jemand mit diesem Namen.')
                }
            }
        }
        if (errors.name) {
            for (const e of errors.name) {
                switch (e) {
                    case "required":
                        actions.setFieldError('name', 'Der Name darf nicht leer sein.')
                    case "unique":
                        actions.setFieldError('name', 'Der Name ist bereits vergeben.')
                }
            }
        }
    }
}